import type { FaireProductEntity } from "../../entity_types/product";

export const p_pa6vrey3pp: FaireProductEntity = {
  token: "p_pa6vrey3pp",
  type: "product",
  name: "Dream It Solitaire Pendant Necklace",
  brandToken: "b_eow5j1bbc8",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/883747eae724a48185b4755b9797da7f5d6148801a9840f9c9da5297712a9c41.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ef3f9d90ec37e4205090867f1eb891cbf19fe078ff10563727b627bebc4b7909.jpeg",
    "https://cdn.faire.com/fastly/c6daf2ba6dc8f7ac9a37038e1593a2d10391615019a0881cf241dc5e5d569723.jpeg",
    "https://cdn.faire.com/fastly/d55910bfe802b49582527e0816c57bc3168b92e2a2fb339ab78045366c14f033.jpeg",
    "https://cdn.faire.com/fastly/6b7b42e2ba6607298e96c6a040a775afc12a9711dec8d3cb939eeb24d09fe258.jpeg",
    "https://cdn.faire.com/fastly/d778f7ffa3850bd961fe694e7fabe386544b291d72e391134c3daa6ca1b62534.jpeg",
    "https://cdn.faire.com/fastly/4989580507ee8da4a8e6ce21b7a4ecb2f18a6e351f63a53e2146e262078c31a7.jpeg",
    "https://cdn.faire.com/fastly/4c933dec7fa55d9a3fc359e27d3fa48a03b7f5fb7179ce725c4d251ca2114956.png",
    "https://cdn.faire.com/fastly/e595228eca49663af4ab029cd9461fcfd49b27cca15cdb83ccb2d3747956634d.png",
  ],
  priceDollars: 13.18,
  description:
    "Classy statement size single stone pendant necklace. Absolutely beautiful in clean clear high grade Cubic Zirconia stone that looks just like a diamond! \n\n- Dimension: 16-inch chain length with a 2-inch extender.\n\n- Gold Plated Stainless Steel chain that last long with no tarnish\n\n-Lead and Nickel Free",
  tags: [],
  msrpDollars: 26.36,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:13.804Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
